export default "__VITE_ASSET__ca2befa1__"